import { call, put, takeEvery } from 'redux-saga/effects';
import { golfApi } from 'config/axios';
import { toQueryString } from 'utils/UrlUtil';

import { FETCH_GOLF_COURSE, FETCH_GOLF_COURSE_SUCCESS, FETCH_GOLF_COURSE_FAIL } from '../actions/golfCourseActions.js';

export function* fetchGolfCourseSaga(action) {
    try {
        const queryString = toQueryString({
            'course-snapshot-ids': action.courseSnapshotId,
            'user-locale': action.userLocale
        });

        const url = `/gcs-golfcommunity/api/v2/course-snapshot${queryString}`;

        const response = yield call(golfApi.get, url);

        yield put({
            type: FETCH_GOLF_COURSE_SUCCESS,
            golfCourse: response.data && response.data.length ? response.data[0] : {}
        });
    } catch (e) {
        yield put({
            type: FETCH_GOLF_COURSE_FAIL,
            golfCourse: {}
        });
    }
}

export const golfCourse = [takeEvery(FETCH_GOLF_COURSE, fetchGolfCourseSaga)];
